import { EChatHintQuestionsActionTypes, TChatHintQuestionsPayload, TShowChatHintQuestionsPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setHintQuestionsHidden = actionGenerator<EChatHintQuestionsActionTypes.Hide, TChatHintQuestionsPayload>(
  EChatHintQuestionsActionTypes.Hide,
);

export const setHintQuestionsVisible = actionGenerator<
  EChatHintQuestionsActionTypes.Show,
  TShowChatHintQuestionsPayload
>(EChatHintQuestionsActionTypes.Show);
